import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-tab-dropdown',
  templateUrl: './tab-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabDropdownComponent {
  @Input() tooltip?: string | TemplateRef<any>;
}
